//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import contact from '~/graphql/mutations/contact.gql';
import page from '~/plugins/mixins/page';

export default {
  auth: false,
  mixins: [page],
  data: () => ({
    formName: 'contact',
    openedDropdown: 0,
    location: {
      lat: 51.65559,
      lng: 5.6217944,
    },
    mapsImage: require('~/assets/img/location-map.png'),
  }),
  methods: {
    async sendContactRequest(data) {
      let failed = false;
      try {
        await this.$apollo.mutate({
          mutation: contact,
          variables: data,
        });
      } catch (e) {
        failed = true;
        this.$toast.error(e);
      }
      if (!failed) {
        this.$toast.success('Bedankt voor uw vraag, deze zal zo spoedig mogelijk beantwoord worden.');
        this.$formulate.reset(this.formName);
      }
    },
  },
};

